export default "__VITE_ASSET__318f83c6__"